import { Theme, alpha } from '@mui/material/styles'
import { ToggleButtonProps } from '@mui/material/ToggleButton'

import { onHover, onHoverOverTint } from '../interaction'

// ----------------------------------------------------------------------

export default function ToggleButton(theme: Theme) {
  const rootStyle = (ownerState: ToggleButtonProps) => {
    const standardColor = ownerState.color === 'standard'

    const defaultStyle = {
      // MUI's default is alpha(text.primary, hoverOpacity), a second neutral that
      // sat one pixel away from action.hover and read as a different colour.
      ...onHover({ backgroundColor: theme.palette.action.hover }),
      '&.Mui-selected': {
        ...(standardColor && { borderColor: 'inherit' }),
        // Over the selection tint, not instead of it.
        ...onHoverOverTint(theme, theme.palette.action.selected),
      },
    }

    const disabledState = {
      '&.Mui-disabled': {
        '&.Mui-selected': {
          color: theme.palette.action.disabled,
          backgroundColor: theme.palette.action.selected,
          borderColor: theme.palette.action.disabledBackground,
        },
      },
    }

    return [defaultStyle, disabledState]
  }

  return {
    MuiToggleButton: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: ToggleButtonProps }) => rootStyle(ownerState),
      },
    },
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          backgroundColor: theme.palette.background.paper,
          border: `solid 1px ${alpha(theme.palette.grey[500], 0.16)}`,
        },
        grouped: {
          margin: 4,
          borderColor: 'transparent !important',
          borderRadius: `${theme.shape.borderRadius}px !important`,
        },
      },
    },
  }
}
